<template>
  <div class="container app-wrapper" :style="pageTopStyle">
    <!-- <div  :style="{backgroundImage: 'url(https://img0.baidu.com/it/u=739245871,522124166&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=500)',with:'100%', height: '6.5rem',borderRadius:'0.5rem' }" ></div> -->
    <loading v-if="loading"></loading>
    <van-pull-refresh v-model="isLoading" @refresh="onPullRefresh" v-else>
      <van-sticky :offset-top="0">
        <head-child class="themed-top-search" :change="true" :theme-color="bannerThemeColor" no-right>
          <template #left>
            <div class="themed-top-search__location" @click="Switch">
              <van-icon name="location-o" size="0.9rem" />
              <span class="themed-top-search__location-text ellipsis">{{ address || '定位中' }}</span>
              <van-icon name="arrow-down" size="0.65rem" />
            </div>
          </template>
          <template #middle>
            <van-search
              v-model="value"
              class="themed-top-search__input"
              placeholder="搜索商品"
              shape="round"
              background="transparent"
              readonly
              @focus="seach1"
            />
          </template>
          <template #right>
            <div class="themed-top-search__service" aria-label="在线客服" @click="openCustomerService">
              <van-icon name="service-o" size="1.4rem" />
            </div>
          </template>
        </head-child>
      </van-sticky>

      <!-- 正常页面 -->
      <div v-if="boo2" style="padding-bottom: 3.5rem; background: transparent">
        <!-- 轮播图：与活动区同宽，左右等距留白 -->
        <div v-if="headData && headData.length" class="home-inset-group">
          <head-index
            ref="homeBanner"
            class="home-banner"
            :headData="headData"
            :form-context="form"
            @banner-change="onBannerThemeChange"
          ></head-index>
        </div>
        <!-- 公告放在 Banner 下方，正常占位 -->
        <platform-notice-bar page-code="mall_home" />
        <div class="home-inset-group home-inset-group--nav">
          <nav-image ref="category"></nav-image>
        </div>
        <div v-if="topActivities.length" class="home-inset-group home-inset-group--activity">
          <lable-image layout="mall" :data-list="topActivities" :form-context="form" zone="top" />
        </div>
        <div v-if="bottomActivities.length" class="home-inset-group home-inset-group--activity">
          <lable-image layout="mall" :data-list="bottomActivities" :form-context="form" zone="bottom" />
        </div>
        <div class="home-inset-group home-inset-group--product">
          <div class="home-product-zone" ref="productZoneRef">
          <TwoLevelProductCategory
            ref="towLevelCategoryRef"
            @change="handleTwoLevel"
          />
          <van-list
            v-model="loading2"
            :finished="finished || !productListReady"
            finished-text="没有更多了"
            @load="nextPage"
          >
            <goods-list-com :DataList="list"> </goods-list-com>
          </van-list>
          </div>
        </div>
      </div>
      <!-- 搜索页面 -->
      <seachview v-else ref="seach" :value="value" @value="seachvalue" :type="2"></seachview>
    </van-pull-refresh>
    <!-- 底部 -->
    <AllNav></AllNav>
    <!-- 引入定位组件并监听定位完成事件 -->
    <LocationComponent @location-finish="onLocationFinish" />
  </div>
</template>

<script>
import { Toast } from "vant";
import HeadChild from "../components/HeadChild";
import HeadIndex from "../components/index/HeadIndex.vue";
import NavImage from "../components/index/NavImage.vue";
import LableImage from "../components/cake/LableImage.vue";
import Seachview from "../components/index/Seachview.vue";
import GoodsListCom from "../components/GoodsListCom.vue";
import AllNav from "../components/footnav/AllNav.vue";
import TwoLevelProductCategory from "../components/home/TwoLevelProductCategory.vue";
import LocationComponent from '@/components/map/Location.vue';
import {
  PAGE_KEYS,
  SECTION_KEYS,
  consumePageViewState,
  getWindowScrollTop,
  isPageViewRestorePending,
  restorePageViewState,
  savePageViewState,
  shouldPreserveViewState,
} from '@/utils/pageScrollRestore';
import { getHomeTopBackgroundStyle, HOME_DEFAULT_TOP_COLOR, setStoredHomeBannerThemeColor } from '@/utils/themeColor';
import { splitActivities } from '@/utils/mallHome';
import { openCustomerService } from '@/utils/customerService';
import { mapState } from 'vuex';
import PlatformNoticeBar from '@/components/PlatformNoticeBar.vue';
export default {
  name: "Home",
  props: {},
  data() {
    return {
      cardShowFlag: null, // 卡类型
      // 容器宽度百分比
      width: 100,
      // 滑轮值
      range: 100,
      //是否根据容器尺寸自动计算重绘
      autoResize: true,
      //列数
      col: 2,
      //是否始终填满容器
      fillBox: false,
      // //列宽-有指定列数则此属性失效
      // colWidth: (pc ? window.innerHeight : window.innerWidth) / 2,
      // // 列数和列宽模式切换
      // mode: 0,
      list: [],
      loading2: false, // 商品列表是否处于加载状态
      finished: false, // 是否加载完了
      tabindexL: 1,
      loading: false,
      headData: [],
      lableData: [],
      hasDThemes: false,
      /** D 区已决议且首屏商品由编排发起后，才允许 van-list 分页 */
      productListReady: false,
      /** 商品请求序号，用于丢弃 Tab 连点时的过期响应 */
      _productReqId: 0,
      _lastBathId: null,

      form: {
        cardId: "",
        current: 1, // 当前页码
        size: 10, // 每页个数
        productName: "",
        category1Id: "",// 二级分类菜单
        cityCode: '',
        upgradeFlag: localStorage.getItem("upgradeFlag"),
        bathId: localStorage.getItem("bathId"),
        id: '',
        hotType: ''
      },

      city: null,
      value: null,
      // 非搜索状态
      boo2: true,
      // 搜索 取消
      boo3: true,
      // 刷新
      isLoading: false,
      // 标记是否已加载数据
      dataLoaded: false,
      /** 当前 Banner 主题色（页顶渐变） */
      bannerThemeColor: HOME_DEFAULT_TOP_COLOR,
    };
  },
  components: {
    TwoLevelProductCategory,
    HeadIndex,
    NavImage,
    HeadChild,
    Seachview,
    LableImage,
    GoodsListCom,
    AllNav,
    LocationComponent,
    PlatformNoticeBar
  },
  methods: {
    syncFormContext() {
      this.form.cardId = localStorage.getItem('cardId') || '';
      this.form.bathId = localStorage.getItem('bathId') || '';
      this.form.upgradeFlag = localStorage.getItem('upgradeFlag') || '';
      this.form.cityCode = this.cityCode || localStorage.getItem('cityCode') || '';
    },

    /**
     * 按 D 区决议写入商品查询口径：有主题 → hotType=D；无则全商品权限
     */
    applyDZoneProductQuery(record) {
      const tab = record && record.data;
      this.hasDThemes = !!(tab && tab.isShowD);
      if (tab && tab.isShowD) {
        this.form.id = tab.id;
        this.form.hotType = 'D';
      } else {
        this.form.id = '';
        this.form.hotType = '';
      }
      this.form.category1Id = '';
    },

    /**
     * D 区 Tab 切换：
     * - 先滚到商品区顶（保留旧列表撑住高度，避免清空塌陷闪出 Banner）
     * - finished 截止分页，请求第 1 页后原子替换列表
     */
    handleTwoLevel(record) {
      const tab = record && record.data;
      // 同一主题不重复请求
      if (tab && tab.isShowD && String(this.form.id) === String(tab.id) && this.form.hotType === 'D') {
        return;
      }
      if (!tab && !this.form.id && !this.form.hotType) {
        return;
      }
      this.applyDZoneProductQuery(record);
      this.productListReady = true;
      this.form.current = 1;
      // 截止分页；不要 list=[]，否则高度塌陷会闪出上方 Banner/分类
      this.finished = true;
      this.loading2 = true;
      this._productReqId = (this._productReqId || 0) + 1;
      const reqId = this._productReqId;
      // 旧列表仍在时先滚到主题商品区，再请求，避免深滚动连翻页
      this.scrollToProductZone();
      this.getData({ reqId, scrollToProduct: true });
    },

    /** 滚动到 D 区主题商品区域顶部（预留吸顶头高度） */
    scrollToProductZone() {
      const el = this.$refs.productZoneRef;
      if (!el || typeof el.getBoundingClientRect !== 'function') {
        return;
      }
      const stickyOffset = 50;
      const top = el.getBoundingClientRect().top + getWindowScrollTop() - stickyOffset;
      const y = Math.max(0, top);
      window.scrollTo(0, y);
      document.documentElement.scrollTop = y;
      document.body.scrollTop = y;
    },

    nextPage() {
      // 首屏由 init 在 D 决议后拉取；此处仅分页
      if (!this.productListReady || this.finished || !this.list.length) {
        this.loading2 = false;
        return;
      }
      this.form.current += 1;
      this.getData();
    },
    getTabIndex(index) {
      this.tabindexL = index;
    },
    // 刷新商品列表（下拉刷新后复用）
    onRefresh() {
      this.finished = false;
      this.form.current = 1;
      this.getData();
    },
    /**
     * @param {{ reqId?: number, scrollToProduct?: boolean }} [options]
     */
    getData(options = {}) {
      const reqId = options.reqId;
      const scrollToProduct = options.scrollToProduct === true;
      this.$nextTick(() => {
        this.$api
          .queryProductInfoHomeNew(this.form)
          .then((res) => {
            // 快速连点 Tab 时丢弃过期响应
            if (reqId != null && reqId !== this._productReqId) {
              return;
            }
            if (res.code == 1) {
              Toast(res.msg);
              this.loading2 = false;
              return;
            }
            const records = (res.data && res.data.records) || [];
            if (this.form.current == 1) {
              // 原子替换，中间不经过空列表
              this.list = records;
            } else {
              this.list.push(...records);
            }
            this.loading = false;
            this.loading2 = false;
            const pages = res.data && res.data.pages != null ? res.data.pages : 1;
            // 先停在商品区顶再放开分页，防止替换瞬间仍处深位时连翻
            if (scrollToProduct) {
              this.$nextTick(() => {
                this.scrollToProductZone();
                this.finished = this.form.current >= pages;
              });
            } else {
              this.finished = this.form.current >= pages;
            }
          })
          .catch(() => {
            if (reqId != null && reqId !== this._productReqId) {
              return;
            }
            this.loading = false;
            this.loading2 = false;
          });
      });
    },
    getBanner() {
      const form = {
        cardId: this.form.cardId,
        cityCode: this.form.cityCode,
        upgradeFlag: this.form.upgradeFlag,
        bathId: this.form.bathId,
        hotType: 'A',
        showPositionCode: '0',
      };
      return this.$api
        .getQueryRotation(form)
        .then((res) => {
          this.headData = res.data;
          if (res.data && res.data.length) {
            const color = res.data[0].themeColor || HOME_DEFAULT_TOP_COLOR;
            this.bannerThemeColor = color;
            setStoredHomeBannerThemeColor(color, 0);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onBannerThemeChange({ index, item }) {
      const color = (item && item.themeColor) ? item.themeColor : HOME_DEFAULT_TOP_COLOR
      this.bannerThemeColor = color
      setStoredHomeBannerThemeColor(color, index)
    },
    syncBannerThemeFromCarousel() {
      this.$nextTick(() => {
        const banner = this.$refs.homeBanner
        if (banner && typeof banner.syncCurrentBanner === 'function') {
          banner.syncCurrentBanner()
        }
      })
    },
    getQueryLabel() {
      const form = {
        cardId: this.form.cardId,
        cityCode: this.form.cityCode,
        upgradeFlag: this.form.upgradeFlag,
        bathId: this.form.bathId,
        hotType: 'B',
        showPositionCode: '0',
      };
      return this.$api
        .getQueryRotation(form)
        .then((res) => {
          this.lableData = res.data || [];
        })
        .catch(() => {
          this.lableData = [];
        });
    },
    // 位置选择
    Switch() {
      this.$router.push("SelectAdderss");
    },
    // 调用子组件的方法
    seach() {
      this.$refs.seach.seach(this.value);
      this.boo3 = false;
    },
    // 取消
    delSeach() {
      this.value = null;
      this.boo3 = true;
      this.$refs.seach.history = true;
      this.$refs.seach.getHistroy();
    },
    // 输入框获取焦点
    seach1() {
      this.$router.push('SearchGoods')
    },
    // 顶部搜索栏客服入口
    openCustomerService,

    // 返回
    goback() {
      this.boo2 = true;
      this.value = null;
      this.$nextTick(() => {
        if (this.$refs.category) {
          this.$refs.category.init();
        }
        if (this.$refs.towLevelCategoryRef) {
          this.$refs.towLevelCategoryRef.init();
        }
      });
    },
    //子组件分发的事件  点击历史记录重新给输入框赋值
    seachvalue(val) {
      this.value = val;
    },
    /**
     * 首页初始化：A/B/D/分类并行，商品严格后置于 D 区决议
     */
    initView(options = {}) {
      const fromH5Return = options.fromH5Return === true
        || isPageViewRestorePending(PAGE_KEYS.HOME);

      localStorage.removeItem('mallSource');
      window.dispatchEvent(new Event('mallSourceChange'));

      const currentBathId = localStorage.getItem('bathId');
      if (this._lastBathId && this._lastBathId !== currentBathId) {
        this.dataLoaded = false;
      }
      this._lastBathId = currentBathId;

      if (this.dataLoaded) {
        if (fromH5Return) {
          this.restoreHomeViewState();
        }
        return Promise.resolve();
      }

      this.syncFormContext();
      if (!this.form.cardId || !this.form.bathId || !this.form.cityCode) {
        return Promise.resolve();
      }

      this.dataLoaded = true;
      this.value = null;
      this.boo2 = true;
      this.hasDThemes = false;
      this.productListReady = false;
      this.list = [];
      this.form.current = 1;
      this.finished = true; // D 决议前禁止 van-list 抢跑
      this.form.id = '';
      this.form.hotType = '';
      this.form.category1Id = '';

      // A/B/D/分类同级并行；商品仅后置于 D 区决议（不因 A/B/分类阻塞）
      return this.$nextTick().then(() => {
        const tasks = [
          this.getBanner(),
          this.getQueryLabel(),
        ];
        if (this.$refs.category) {
          tasks.push(this.$refs.category.init());
        }
        const dZoneTask = this.$refs.towLevelCategoryRef
          ? this.$refs.towLevelCategoryRef.init()
          : Promise.resolve({ data: null, index: 0 });
        tasks.push(dZoneTask);

        // D 一决议即拉商品：有主题 → D 主题商品；无 → 全商品权限
        const productTask = dZoneTask.then((dRecord) => {
          this.applyDZoneProductQuery(dRecord);
          this.productListReady = true;
          this.finished = false;
          this.form.current = 1;
          this.list = [];
          this.getData();
        });

        return Promise.all(tasks.concat([productTask])).then(() => {
          if (fromH5Return) {
            this.restoreHomeViewState();
          }
        });
      });
    },

    /** 统一恢复：纵向滚动 + 分类 swipe（三方 H5 / 详情返回） */
    restoreHomeViewState() {
      if (!isPageViewRestorePending(PAGE_KEYS.HOME)) {
        return;
      }
      this.$nextTick(() => {
        restorePageViewState(PAGE_KEYS.HOME, {
          [SECTION_KEYS.NAV_SWIPE]: (index) => {
            if (this.$refs.category) {
              this.$refs.category.applySwipeIndex(index);
            }
          },
        });
      });
    },

    onPageShow(event) {
      if (this.$route.path !== '/HomeNew') {
        return;
      }
      if (!isPageViewRestorePending(PAGE_KEYS.HOME)) {
        return;
      }
      if (event.persisted) {
        this.$nextTick(() => this.restoreHomeViewState());
        return;
      }
      if (this.dataLoaded) {
        this.restoreHomeViewState();
      }
    },

    onPullRefresh() {
      this.dataLoaded = false;
      this.productListReady = false;
      this.finished = true;
      this.loading2 = false;
      this.list = [];
      this.form.current = 1;
      Promise.resolve(this.initView()).finally(() => {
        this.isLoading = false;
      });
    },
    
    /**
     * 定位完成后的回调
     * @param {Object} locationInfo 定位信息
     */
    onLocationFinish(locationInfo) {
      if (locationInfo && locationInfo.cityCode) {
        this.form.cityCode = locationInfo.cityCode;
      }
      this.dataLoaded = false;
      this.initView();
    }
  },
  inject: ["reload"],
  beforeRouteEnter(to, from, next) {
    to.meta.keepAlive = true
    const fromPreservePage = shouldPreserveViewState(from.path);
    const h5ReturnPending = isPageViewRestorePending(PAGE_KEYS.HOME);

    // 详情/搜索/商品列表返回：保留列表，按快照恢复浏览位置（已加载则不整页重拉）
    if (h5ReturnPending || fromPreservePage) {
      next((vm) => {
        vm.$nextTick(() => {
          vm.initView({ fromH5Return: true });
        });
      });
      return;
    }

    next((vm) => {
      vm.$nextTick(() => {
        vm.initView()
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0
      })
    });
  },
  mounted() {
    window.addEventListener('pageshow', this.onPageShow);
  },
  beforeDestroy() {
    window.removeEventListener('pageshow', this.onPageShow);
  },
  activated() {
    this.syncBannerThemeFromCarousel();
    if (isPageViewRestorePending(PAGE_KEYS.HOME) && this.dataLoaded) {
      this.restoreHomeViewState();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (shouldPreserveViewState(to.path)) {
      savePageViewState(PAGE_KEYS.HOME, {
        scrollTop: getWindowScrollTop(),
        sections: {
          [SECTION_KEYS.NAV_SWIPE]: this.$refs.category ? this.$refs.category.current : 0,
        },
      });
    } else {
      consumePageViewState(PAGE_KEYS.HOME);
    }
    next();
  },
  computed: {
    // 获取定位地址信息
    ...mapState({
      address: state => state.address,
      cityCode: state => state.cityCode
    }),
    pageTopStyle() {
      return getHomeTopBackgroundStyle(this.bannerThemeColor)
    },
    activitySplit() {
      return splitActivities(this.lableData);
    },
    topActivities() {
      return this.activitySplit.top;
    },
    bottomActivities() {
      return this.activitySplit.bottom;
    },
  },
  watch: {
    value(val, oldval) {
      if (oldval !== "") {
        this.boo3 = true;
      }
    },
    /**
     * 路由变化时默认标记需重新拉数。
     * 进详情/搜索/商品列表等子页，或从这些页返回时保留 dataLoaded，
     * 避免 keep-alive 失效导致 D 区浏览位置丢失。
     */
    '$route'(to, from) {
      const toPath = (to && to.path) || '';
      const fromPath = (from && from.path) || '';
      if (shouldPreserveViewState(toPath) || shouldPreserveViewState(fromPath)) {
        return;
      }
      if (isPageViewRestorePending(PAGE_KEYS.HOME)) {
        return;
      }
      this.dataLoaded = false;
    },
    cityCode(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.dataLoaded = false;
        this.form.cityCode = newVal;
        this.initView();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container-water-fall {

  /* // padding: 0 28px; */
  padding: 0 3%;
  width: 100vw;
  box-sizing: border-box;
  /* background: #fafafa !important; */
}

.cell-item {
  background: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  box-sizing: border-box;
  margin: 5% 0;
}

.cell-item img {
  width: 100%;
  height: auto;
  display: block;
}

@import '@/styles/themedTopSearch.scss';

.home-inset-group {
  padding: 0 0.5rem;
  box-sizing: border-box;
}

.home-inset-group--nav {
  margin-top: 0.375rem;
}

.home-inset-group--activity {
  margin-top: 0.375rem;
}

.home-inset-group--product {
  margin-top: 0.5rem;
}

.home-inset-group :deep(.home-banner) {
  display: block;
  height: 8.14rem;
  margin-bottom: 0;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 0.5rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.home-product-zone {
  box-sizing: border-box;
  background: #fff;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.container {
  transition: background-image 0.45s ease;
}

.gridDivImg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  width: 100%;
  height: 12rem;
}

.empty {
  transform: translateY(50%);
}

/*瀑布流对应布局开始*/
.main {
  height: max-height;
  flex: auto;
  overflow-y: auto;
  overflow-x: hidden;

  /*瀑布流对应布局开始*/
  .waterfall-item {
    margin: 5px;
    background: white;
    box-sizing: border-box;
    font-size: 1rem;
    display: flex;
    flex-direction: column;
    border-radius: 0.5rem;
    padding-bottom: 1rem;
  }

  .waterfall-item img {
    width: 100%;
    display: block;
  }

  .bounceIn {
    animation-name: bounceIn;
    animation-duration: 0.6s;
    animation-timing-function: linear;
    transform-origin: center center;
  }

  @keyframes bounceIn {
    0% {
      opacity: 0;
      -webkit-transform: scale(0.3);
      -ms-transform: scale(0.3);
      transform: scale(0.3);
    }

    50% {
      opacity: 1;
      -webkit-transform: scale(1.05);
      -ms-transform: scale(1.05);
      transform: scale(1.05);
    }

    70% {
      -webkit-transform: scale(0.9);
      -ms-transform: scale(0.9);
      transform: scale(0.9);
    }

    100% {
      opacity: 1;
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }
  }
}

.texttitle {
  font-size: 0.875rem;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-height: 2.5rem;

  padding-top: 0.5rem;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.textFoot {
  font-size: 1.125rem;
  color: #d23b2e;
  letter-spacing: 0;
  font-weight: 500;
  height: 2rem;
  margin-left: 0.75rem;
  margin-top: 0.25rem;
  margin-bottom: 0.3125rem;
}

::-webkit-scrollbar {
  width: 0px;
}

::-webkit-scrollbar-track {
  background-color: none;
}

::-webkit-scrollbar-thumb {
  background-color: none;
}

::-webkit-scrollbar-thumb:hover {
  background-color: none;
}

::-webkit-scrollbar-thumb:active {
  background-color: none;
}

/*瀑布流对应布局结束*/
</style>
